module.exports = __webpack_public_path__ + "img/bandui_sel.c2bc8730.png";